/**
 * Easy way to better handle a category (tag) structure in the client side
 */
class CategoryRef {
  constructor(
    readonly _id: string,
    readonly _name: Nullable<string>,
    readonly _count: Nullable<number>,
  ) {}

  static build(serverObj: CategoryRef) {
    return new CategoryRef(serverObj._id, serverObj._name, serverObj._count);
  }

  static buildFromTagify(obj: any) {
    return new CategoryRef(obj.id, obj.value.toLowerCase(), obj.count);
  }

  id() {
    return this._id;
  }

  name() {
    return this._name;
  }

  count() {
    return this._count;
  }
}

export default CategoryRef;
